import { FC, useContext, useEffect, useState } from "react";
import LayoutComponent from "../../../layouts/layoutComponent/LayoutComponent";
import { useNavigate, useParams } from "react-router-dom";
import UserEntity from "../../../../domain/entities/UserEntity";
import di from "../../../../DependencyInjection";
import GetUserByIdUseCase, { GetUserByIdUseCaseName } from "../../../../domain/use_cases/user/GetUserByIdUseCase";
import { isLeft } from "fp-ts/lib/Either";
import { useForm } from "react-hook-form";
import KeyWordLocalization from "../../../utils/KeyWordLocalization";
import LocalizationContext from "../../../providers/localization/LocalizationContext";
import LocalizationContextType from "../../../../domain/providers/localization/LocalizationContextType";
import { ErrorMessage } from "@hookform/error-message";
import Validators from "../../../utils/Validators";
import ButtonComponent from "../../../components/button/ButtonComponent";
import ModalsContext from "../../../providers/modal/ModalsContext";
import ModalsContextType from "../../../../domain/providers/modal/ModalsContextType";
import NotFoundComponent from "../../../components/notFound/NotFoundComponent";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent";

const CreateUserPage: FC<{}> = () => {
    const { id } = useParams<{ id: string }>();
    const { register, handleSubmit, getValues, setValue, watch, formState: { errors } } = useForm();
    const { i18n } = useContext(LocalizationContext) as LocalizationContextType;
    const { addToast, openModalCustom, openModalDelete } = useContext(ModalsContext) as ModalsContextType;
    const [user, setUser] = useState<UserEntity | null | undefined>(undefined);
    const navigate = useNavigate();

    const _handleCreateUser = async (data: any) => {
        // const fakeUser: UserEntity = {
        //     id: '',
        //     name: data[KeyWordLocalization.CreateUserPageTitle],
        //     role: data[KeyWordLocalization.CreateUserPageTitle],
        // };
        // if (questions.length == 0) return addToast(i18n(KeyWordLocalization.CreateUserPageNoQuestions), 'error', undefined);
        // const response = await di.get<CreateUserUseCase>(CreateUserUseCaseName).call(fakeUser);
        // if (isLeft(response)) return addToast(i18n(KeyWordLocalization.CreateUserPageCreateError), 'error', undefined);
        // addToast(i18n(KeyWordLocalization.CreateUserPageCreateSuccess), 'success', undefined);
        // navigate(routes.user.relativePathWithParams({ id: response.right.id }), {
        //     replace: true,
        // });
    }

    const _searchUser = async () => {
        if (id == undefined) return setUser(null);
        const response = await di.get<GetUserByIdUseCase>(GetUserByIdUseCaseName).call(id);
        if (isLeft(response)) return setUser(null);
        setUser(response.right);
        setValue(KeyWordLocalization.CreateUserPageTitle, response.right.name);
    }

    useEffect(() => {
        _searchUser();
    }, [id]);

    if (user == null && id) return <div className="update_user_page">
        <LayoutComponent title={i18n(KeyWordLocalization.CreateUserPageEditTitle)}>
            <div className="container">
                {user === null ?
                    <NotFoundComponent />
                    : <LoadingComponent />}
            </div>
        </LayoutComponent>
    </div>

    return <div className="create_user_page">
        <LayoutComponent title={i18n(id != null ? KeyWordLocalization.CreateUserPageEditTitle : KeyWordLocalization.CreateUserPageAddTitle)}>
            <div className="container">
                <form onSubmit={handleSubmit(_handleCreateUser)}>
                    <div className={`form-group my-3 ${errors[KeyWordLocalization.CreateUserPageTitle] && 'error error_group'}`}>
                        <label className='form-label'>{i18n(KeyWordLocalization.CreateUserPageTitle)}</label>
                        <input type="text" disabled={user != null} className="form-control" placeholder={i18n(KeyWordLocalization.CreateUserPageTitle)} {...register(KeyWordLocalization.CreateUserPageTitle, Validators({
                            required: true,
                            minLength: 5,
                        }))} />
                        <ErrorMessage as={"aside"} errors={errors} name={KeyWordLocalization.CreateUserPageTitle} />
                    </div>
                    <div className="card">
                        <div className="card-body">
                            Create user
                        </div>
                    </div>
                    <div className="w-100 d-flex justify-content-end my-3">
                        {user == null &&
                            <ButtonComponent icon={<span className="material-symbols-outlined">
                                add </span>} type="submit" design="primary" text={i18n(KeyWordLocalization.CreateUserCreate)} />}
                    </div>
                </form>
            </div>
        </LayoutComponent>
    </div >
};

export default CreateUserPage;